import axios from 'axios'

// 后端网关基础地址，根据实际部署环境调整
const service = axios.create({
  baseURL: '/api',
  timeout: 80000  // 增加超时时间
})

// ==================== 单张识别相关 ====================
// 上传单张验证码图片进行识别
export function identifyCaptcha(file) {
  const formData = new FormData()
  formData.append('file', file)

  return service.post('/captcha/identify', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取识别历史记录（分页）
export function getHistory(page = 1, size = 10) {
  return service.get('/captcha/history', {
    params: { page, size }
  })
}

// ==================== 批量任务相关 ====================
// 创建批量任务
export function createBatchTask(taskName, taskDesc) {
  const params = new URLSearchParams()
  params.append('taskName', taskName)
  if (taskDesc) params.append('taskDesc', taskDesc)
  return service.post('/batch/create', params)
}

// 批量上传文件并创建任务
export function uploadBatchTask(formData) {
  return service.post('/batch/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 分页查询批量任务列表
export function getBatchList(params) {
  return service.get('/batch/list', { params })
}

// 查询批量任务详情（根据 batchId）
export function getBatchDetail(batchId) {
  return service.get('/batch/detail', { params: { batchId } })
}

// 终止批量任务
export function stopBatchTask(taskId) {
  const params = new URLSearchParams()
  params.append('taskId', taskId)
  return service.post('/batch/stop', params)
}

// ==================== 日志管理相关 ====================

// 根据任务名称搜索批次
export function searchBatchesByName(params) {
  return service.get('/batch/search-by-name', { params })
}

// 标记识别结果是否正确
export function markCorrect(logId, isCorrected) {
  const params = new URLSearchParams()
  params.append('logId', logId)
  params.append('isCorrected', isCorrected)
  return service.post('/log/mark-correct', params)
}

// 人工修正识别结果
export function correctResult(logId, correctResult) {
  const params = new URLSearchParams()
  params.append('logId', logId)
  params.append('correctResult', correctResult)
  return service.post('/log/correct-result', params)
}

// 根据批次号查询日志列表（分页）
export function getLogsByBatch(batchId, page = 1, size = 10) {
  return service.get('/log/list-by-batch', {
    params: { batchId, page, size }
  })
}

// 获取全局统计数据
export function getGlobalStats() {
  return service.get('/log/stats/global')
}

// 获取模型训练历史
export function getModelHistory() {
  return service.get('/model/history')
}

// 下载模型文件
export function downloadModelFile(filename) {
  return service.get(`/model/download/${filename}`, { responseType: 'blob' })
}

// 导出批次结果（返回文件流）
export function downloadBatchResult(batchId) {
  return service.get('/batch/export', {
    params: { batchId },
    responseType: 'blob'  // 告诉 axios 返回二进制数据
  })
}

// 应用指定版本的模型
export function applyModelVersion(filename) {
  return service.post(`/model/apply/${filename}`)
}

// 获取模型分析数据
export function getModelAnalysis(filename) {
  return service.get(`/model/analyze/${filename}`)
}

// 上传模型文件
export function uploadModel(formData) {
  return service.post('/model/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 开始评测
export function startEvaluation(uploadId) {
  return service.post(`/model/evaluate/${uploadId}`, null, {
    timeout: 30000  // 30秒超时，避免因后端处理慢而失败
  })
}

// 获取评测结果
export function getEvaluationResult(uploadId) {
  return service.get(`/model/result/${uploadId}`)
}

// 获取批次统计信息
export function getBatchStats(batchId) {
  return service.get('/log/batch-stats', { params: { batchId } })
}